
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import Collapse from './Collapse';

import styles from '../Fieldset/styles.js';

class ExtraFiltersCollapse extends Component {
    static propTypes = {
        classId: PropTypes.number,
        collapseText: PropTypes.string,
        expandText: PropTypes.string,
        extraFilters: PropTypes.array.isRequired,
        filterGroupIndex: PropTypes.number.isRequired,
        handleExpand: PropTypes.func.isRequired,
        handleExpanded: PropTypes.func.isRequired,
        isExpanded: PropTypes.number.isRequired,
        isFullScreenPanel: PropTypes.bool,
        isSmallScreenPanel: PropTypes.bool,
        title: PropTypes.string.isRequired
    }

    static defaultProps = {
        classId: null,
        isSmallScreenPanel: false,
        isFullScreenPanel: false
    }

    state = {
        animating: false
    }

    componentDidMount() {
        const { handleToggle } = this;
        handleToggle();
    }

    handleToggle = () => {
        const {
            classId,
            filterGroupIndex,
            handleExpand,
            handleExpanded
        } = this.props;
        if (classId === 1) {
            setTimeout(() => {
                this.setState({ animating: true });
                setTimeout(() => {
                    handleExpanded(filterGroupIndex, 2);
                }, 250);
            }, 50);
        } else if (classId === 3) {
            this.setState({ animating: true });
            setTimeout(() => {
                handleExpand(filterGroupIndex);
            }, 250);
        }
    }

    toggleExtraFilters = () => {
        const {
            classId,
            filterGroupIndex,
            handleExpand,
            handleExpanded
        } = this.props;
        if (classId === 0) {
            handleExpand(filterGroupIndex, 1);
        } else {
            handleExpanded(filterGroupIndex, 3);
        }
    }

    render() {
        const {
            handleExpanded,
            toggleExtraFilters
        } = this;
        const {
            classId,
            collapseText,
            expandText,
            extraFilters,
            isExpanded,
            isFullScreenPanel,
            isSmallScreenPanel
        } = this.props;
        const { animating } = this.state;
        let className = 'childContainer_hidden';
        if (classId === 1 && animating) {
            className = 'childContainer_opening';
        } else if (classId === 2) {
            className = 'childContainer_shown';
        } else if (classId === 3) {
            if (animating) {
                className = 'childContainer_closing';
            } else {
                className = 'childContainer_shown';
            }
        }
        return (
            <div
                style={
                    isFullScreenPanel ?
                        {
                            marginBottom: '16px'
                        } : isExpanded ?
                            {
                                marginTop: '16px',
                                marginBottom: '16px'
                            } : null
                }
            >
                <div className={css(styles.containerOverflowHidden)}>
                    {
                        isExpanded ?
                            <Collapse
                                extraFilters={extraFilters}
                                className={className}
                                handleExpanded={handleExpanded}
                            /> : null
                    }
                </div>
                {
                    isSmallScreenPanel ?
                        isExpanded ?
                            <div style={{ marginTop: '16px', marginBottom: '24px' }}>
                                <div className={css(styles.textExtra)}>
                                    <button
                                        id="buttonCollapse"
                                        type="button"
                                        className={css(styles.buttonText)}
                                        aria-disabled="false"
                                        aria-busy="false"
                                        onClick={toggleExtraFilters}
                                    >
                                        <div className={css(styles.containerTable)}>
                                            {
                                                collapseText || expandText ?
                                                    <div className={css(styles.containerTableChild)}>
                                                        <span>{
                                                            isExpanded ?
                                                                `${collapseText}` :
                                                                `${expandText}`
                                                        }</span>
                                                    </div> : null
                                            }
                                            <div className={css(styles.containerTableChild)}>
                                                <div style={{ marginLeft: '8px' }}>
                                                    <div
                                                        className={css(styles.iconWrapper)}
                                                        style={
                                                            isExpanded ?
                                                                { transform: 'rotate(180deg)' } :
                                                                { transform: 'rotate(0deg)' }
                                                        }
                                                    >
                                                        <svg
                                                            viewBox="0 0 18 18"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            style={{
                                                                display: 'block',
                                                                fill: 'currentcolor',
                                                                height: '10px',
                                                                width: '10px'
                                                            }}
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div> : null :
                        <div style={{ marginTop: '8px', marginBottom: '24px' }}>
                            <div className={css(styles.textExtra)}>
                                <button
                                    id="buttonCollapse"
                                    type="button"
                                    className={css(styles.buttonText)}
                                    aria-disabled="false"
                                    aria-busy="false"
                                    onClick={toggleExtraFilters}
                                >
                                    <div className={css(styles.containerTable)}>
                                        {
                                            collapseText || expandText ?
                                                <div className={css(styles.containerTableChild)}>
                                                    <span>{
                                                        isExpanded ?
                                                            `${collapseText}` :
                                                            `${expandText}`
                                                    }</span>
                                                </div> : null
                                        }
                                        <div className={css(styles.containerTableChild)}>
                                            <div style={{ marginLeft: '8px' }}>
                                                <div
                                                    className={css(styles.iconWrapper)}
                                                    style={
                                                        isExpanded ?
                                                            { transform: 'rotate(180deg)' } :
                                                            { transform: 'rotate(0deg)' }
                                                    }
                                                >
                                                    <svg
                                                        viewBox="0 0 18 18"
                                                        role="presentation"
                                                        aria-hidden="true"
                                                        focusable="false"
                                                        style={{
                                                            display: 'block',
                                                            fill: 'currentcolor',
                                                            height: '10px',
                                                            width: '10px'
                                                        }}
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default ExtraFiltersCollapse;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/ExtraFiltersCollapse/ExtraFiltersCollapse.jsx